export const MISSING_FIELD_ERROR_CODE = 'field_missing_in_schemas';

export type MissingFieldErrorExtensions = {
  code: typeof MISSING_FIELD_ERROR_CODE;
  status: 200; // Mimicking backend behavior
  topLevelField: string;
};

type ExtensionsErrorOrNever<T> = T extends OperationErrors ? T : never;

export type GqlError<TErrorExtensions = OperationErrors> = {
  message: string;
  path: ReadonlyArray<string | number> | null | undefined;
  locations?:
    | ReadonlyArray<{
        line: number;
        column: number;
      }>
    | null
    | undefined;
  extensions: {
    actionId: string | null;
    traceId: string | null;
    unstable_requestId: string | null;
    error: ExtensionsErrorOrNever<OperationErrors & TErrorExtensions>;
  };
};

export type OperationErrors = {
  status: number;
  code: string;
};
